import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    appService: AppService,
  ) {
    this.appData = appService.settings;
  }

  logout(): Observable<any> {
    return this.httpClient.get(`${this.appData.webApi}/logout`);
  }

}
